import React from 'react'
import { Link } from 'react-router'
import get from 'lodash/get'
import moment from 'moment'
import numeral from 'numeral'
import formatMoney from '../../util'

export const moneyCellRenderer = ({dataKey, rowData, rowIndex}) => {
  return formatMoney(get(rowData, dataKey))
}

export const filterCellRenderer = ({location, filter, dataKey, rowData, rowIndex}) => {
	const path = [get(location, 'pathname'), `${filter}=${rowData[dataKey]}`].join('?')
  return <Link to={path}>{rowData[dataKey]}</Link>
}

export const dateCellRenderer = function({getTarget, rowData, rowIndex, dataKey, data}) {
  if(!get(rowData, dataKey)) { return '' }
  const content = moment(get(rowData, dataKey)).format('DD/MM/YYYY h:mm a')

  if(getTarget) {
    return <Link to={getTarget(rowData)}>{content}</Link>
  } else {
    return content
  }
}

export const percentCellRenderer = function({rowData, rowIndex, dataKey}) {
	return numeral(rowData[dataKey]).format('0.00%')
}


// WEBPACK FOOTER //
// ./src/components/Generic/TableColumns.js